import axios from 'axios';
import {
  isMaintenanceActive,
  redirectToMaintenancePage,
} from 'helpers/maintenance';

export default function buildOctaneClient() {
  const instance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_OCTANE_URL,
  });

  let token;
  let trackingId;

  instance.setJwtToken = (newToken) => {
    token = newToken;
  };

  instance.getJwtToken = () => token;

  instance.clearJwtToken = () => {
    token = null;
  };

  instance.setTrackingId = (newTrackingId) => {
    trackingId = newTrackingId;
  };

  instance.interceptors.request.use(
    (conf) => {
      if (token) {
        conf.headers.authorization = `Bearer ${token}`;
      }

      if (trackingId) {
        conf.headers.trackingId = trackingId;
      }

      conf.headers.sourceType = 'Consumer';

      return conf;
    },
    (error) => {
      // https://github.com/axios/axios/issues/383
      const isNetworkError = !error?.status;
      if (!isNetworkError) {
        return Promise.reject(error);
      }
    },
  );

  instance.interceptors.response.use(
    (response) => response.data,
    async (error) => {
      if (error.response?.status === 503) {
        return redirectToMaintenancePage();
      }

      // No readable response = opaque network/CORS error. A maintenance 503 from
      // the cross-origin API usually arrives without CORS headers, so the browser
      // hides its status from us. Confirm against belong-next's oracle (which we
      // can read cross-origin) before treating it as a normal failure.
      if (!error.response && (await isMaintenanceActive())) {
        return redirectToMaintenancePage();
      }

      return Promise.reject(error);
    },
  );

  return instance;
}
